import Api from '@/api/Api';
import errorHandler from '@/utils/plugins/ErrorHandler';

const RESOURCE_NAME = '/api/extranet_users';

export default {
    getPermissions(extranetUserId) {
        return Api().get(RESOURCE_NAME + `/${extranetUserId}/permissions`)
            .catch((err) => errorHandler(err, null));
    },
    updatePermissions(extranetUserId, rows) {
        return Api().put(RESOURCE_NAME + `/${extranetUserId}/permissions`, rows)
            .catch((err) => errorHandler(err, null));
    },
}
